{
  "name": "arcdx",
  "version": "5.4.1",
  "scripts": {
    "dev": "ng serve --configuration development --hmr --poll 2000",
    "start": "ng serve --configuration development",
    "start-prod": "ng serve -c production",
    "start-local": "concurrently \"npm run watch\" \"ng serve --configuration development\" ",
    "---- Build ----": "-----------------------------------------------------------------",
    "build": "npm run copy-package && ng build --configuration development",
    "build-config": "node scripts/config/deploy-all-config-assets.js",
    "build-prod": "ng build --configuration production && npm run copy-package",
    "bundle-report": "ng build --configuration production-stats && esbuild-analyzer dist/ssr/stats.json",
    "copy-package": "cpx exporter-util/package.json dist/script -u",
    "merge-flavor": "merge-json --name flavor --output ./src/assets/dictionary/dictionary.json --pattern \"./src/**/*.{{name}}.json\"",
    "---- Lint ----": "-----------------------------------------------------------------",
    "lint": "ng lint memberportal",
    "lint-ado": "ng lint memberportal --format=json > report.json",
    "lint-fix": "ng lint memberportal --fix",
    "---- Test ----": "-----------------------------------------------------------------",
    "test": "ng test --browsers ChromeHeadless",
    "test-watch": "ng test --watch",
    "test-codecoverage": "ng test --code-coverage=true --browsers=ChromeHeadless --watch=false",
    "---- Playwright ----": "-----------------------------------------------------------------",
    "start-playwright": "concurrently --names \"parent,child\" \"serve -p 4200 --single .\\playwright\\home-banking\" \"ng serve -c production --port 4321\"",
    "start-playwright-debug": "concurrently --names \"parent,child\" \"serve -p 4200 --single ./playwright/home-banking\" \"ng serve -c development --port 4321\"",
    "start-playwright-alt": "concurrently --names \"root,alt\" \"serve -p 4200 --single ./playwright/home-banking\" \"ng serve -c production --port 4322\"",
    "start-playwright-brand": "concurrently --names \"root,brand\" \"serve -p 4200 --single ./playwright/home-banking\" \"ng serve -c production --port 1234\"",
    "start-playwright-all": "concurrently --names \"root,main,alt,brand\" \"serve -p 4200 --single ./playwright/home-banking\" \"ng serve -c production --port 4321\" \"ng serve -c production --port 4322\" \"ng serve -c production --port 1234\"",
    "start-playwright-all-local": "concurrently --names \"root,main,alt,brand\" --kill-others \"serve -p 4200 --single ./playwright/home-banking\" \"serve -p 4321 --single ./dist/static/browser\" \"serve -p 4322 --single ./dist/static/browser\" \"serve -p 1234 --single ./dist/static/browser\"",
    "---- MemberPortal ----": "-----------------------------------------------------------------",
    "memberportal:browser-dev": "ng serve memberportal --hmr --poll 2000",
    "memberportal:ssr-build": "ng build memberportal",
    "memberportal:ssr-dev": "ng run memberportal:serve-ssr",
    "memberportal:ssr-start": "node dist/memberportal/server/server.mjs",
    "memberportal:ssr-preview": "npm run ssr-memberportal:build && npm run ssr-memberportal:start",
    "---- Misc ----": "-----------------------------------------------------------------",
    "npm-auth": "vsts-npm-auth -config .npmrc -f",
    "local-shared": "node scripts/local-shared.js",
    "local-login": "node scripts/local-login.js",
    "prettier": "npx prettier --write .",
    "ng": "ng",
    "watch": "npm-watch",
    "postinstall": "node scripts/install-rollup-binary.js"
  },
  "private": true,
  "dependencies": {
    "@alloyidentity/web-sdk": "2.2.5",
    "@angular/animations": "^20.2.1",
    "@angular/cdk": "^20.2.0",
    "@angular/common": "^20.2.1",
    "@angular/compiler": "^20.2.1",
    "@angular/core": "^20.2.1",
    "@angular/forms": "^20.2.1",
    "@angular/material": "^20.2.0",
    "@angular/platform-browser": "^20.2.1",
    "@angular/platform-browser-dynamic": "^20.2.1",
    "@angular/platform-server": "^20.3.0",
    "@angular/router": "^20.2.1",
    "@angular/ssr": "^20.3.0",
    "@cudirect/builders": "1.0.4",
    "@cudirect/ea-login": "20.1.1",
    "@cudirect/hybrid": "1.0.2",
    "@cudirect/plugins": "20.3.1",
    "@cudirect/sawdust": "20.3.1",
    "@cudirect/shared-ui-library": "20.4.1",
    "@datadog/browser-logs": "^6.6.4",
    "@datadog/browser-rum": "^6.5.0",
    "@loglayer/transport-datadog-browser-logs": "^2.1.1",
    "angular-code-input": "^2.0.0",
    "crypto-es": "^3.0.1",
    "escape-string-regexp": "^5.0.0",
    "express-rate-limit": "^7.5.1",
    "helmet": "^7.2.0",
    "loglayer": "^6.4.0",
    "ng-recaptcha-2": "^16.0.1",
    "ngx-extended-pdf-viewer": "^25.6.0-alpha.3",
    "ngx-mask": "^16.4.2",
    "ngx-quill": "28.0.1",
    "parchment": "^3.0.0",
    "quill": "2.0.2",
    "rxjs": "~7.8.0",
    "serialize-error": "^12.0.0",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^20.2.0",
    "@angular-eslint/eslint-plugin": "^20.2.0",
    "@angular-eslint/eslint-plugin-template": "^20.2.0",
    "@angular-eslint/schematics": "^20.2.0",
    "@angular-eslint/template-parser": "^20.2.0",
    "@angular/build": "^20.2.0",
    "@angular/cli": "^20.2.0",
    "@angular/compiler-cli": "^20.2.1",
    "@angular/language-service": "^20.2.1",
    "@angular/localize": "^20.2.1",
    "@eslint/compat": "^1.3.2",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.34.0",
    "@html-eslint/eslint-plugin": "~0.45.0",
    "@html-eslint/parser": "~0.45.0",
    "@testing-library/angular": "^18.0.0",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^6.8.0",
    "@testing-library/user-event": "^14.6.1",
    "@types/express": "^5.0.1",
    "@types/googlemaps": "^3.37.6",
    "@types/jasmine": "~5.1.9",
    "@types/jasminewd2": "~2.0.13",
    "@types/jest": "^30.0.0",
    "@types/node": "^24.3.0",
    "@typescript-eslint/eslint-plugin": "~8.45.0",
    "@typescript-eslint/parser": "~8.45.0",
    "@typescript-eslint/type-utils": "~8.45.0",
    "@typescript-eslint/types": "~8.45.0",
    "@typescript-eslint/utils": "~8.45.0",
    "cheerio": "^1.0.0",
    "concurrently": "^8.2.2",
    "cpx2": "^8.0.0",
    "esbuild-analyzer": "^0.2.0",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^9.37.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.4",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^54.7.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prefer-arrow-functions": "^3.9.1",
    "eslint-plugin-prettier": "^5.5.4",
    "glob": "^10.4.5",
    "globals": "^16.3.0",
    "jasmine-core": "~5.9.0",
    "jasmine-data-provider-ts": "^1.4.6",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "karma-junit-reporter": "~2.0.1",
    "karma-spec-reporter": "^0.0.36",
    "lmdb": "^3.4.2",
    "npm-watch": "^0.13.0",
    "prettier": "^3.5.3",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "prettier-plugin-organize-imports": "^4.1.0",
    "serve": "^14.2.5",
    "ts-jest": "^29.4.4",
    "ts-node": "^10.9.2",
    "tslint-config-prettier": "1.18.0",
    "typescript": "5.9.3"
  },
  "overrides": {
    "adm-zip": "0.5.2",
    "merge": "2.1.1",
    "rimraf": {
      "glob": "10.4.5"
    },
    "glob": {
      "foreground-child": {
        "cross-spawn": "7.0.5"
      }
    }
  }
}
